import { render, staticRenderFns } from "./VimeoVideo.vue?vue&type=template&id=9803c684&"
import script from "./VimeoVideo.vue?vue&type=script&lang=js&"
export * from "./VimeoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports